module.exports = __webpack_public_path__ + "static/media/logo-3.a8713081.png";